
    try {
        if (window.navigator && navigator.serviceWorker) {
            navigator.serviceWorker.getRegistrations()
                .then(function (registrations) {
                    for (let registration of registrations) {
                        //if (registration.scope.includes(window.location.origin))
                        registration.unregister();
                        console.log("Service Worker unregistered " + registration);
                    }
                });
        }
        if (window.localStorage.getItem('oidc.login.default'))
            window.localStorage.removeItem('oidc.login.default')
        if (window.localStorage.getItem('oidc.server:https://connect.identity.stagaws.visma.com'))
            window.localStorage.removeItem('oidc.server:https://connect.identity.stagaws.visma.com')
        if (window.localStorage.getItem('oidc.server:https://connect.visma.com'))
            window.localStorage.removeItem('oidc.server:https://connect.visma.com')
    } catch (e) {
        console.error("Error unregistering service workers", e);
    }

    if (window.caches) {
        window.caches.keys().then(function (cacheNames) {
            cacheNames.forEach(function (cacheName) {
                window.caches.delete(cacheName);
            });
        });
    }
